/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Contact_Code_Type_TextInputs */

const en_enum_contact_code_type_text = /** @type {(inputs: Enum_Contact_Code_Type_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code Type Text`)
};

const de_enum_contact_code_type_text = /** @type {(inputs: Enum_Contact_Code_Type_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code Typ Text`)
};

/**
* | output |
* | --- |
* | "Code Type Text" |
*
* @param {Enum_Contact_Code_Type_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_contact_code_type_text = /** @type {((inputs?: Enum_Contact_Code_Type_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Contact_Code_Type_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_contact_code_type_text(inputs)
	return de_enum_contact_code_type_text(inputs)
});